import { BasisForRepresentation } from '../components';
import { useBasisForRepresentation } from '../hooks';
import { PageComponentProps } from '../types';

export const BasisForRepresentationStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    files,
    goToBack,
    initialValues,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    submitDisabled,
    submitLoading,
  } = useBasisForRepresentation();

  return (
    <BasisForRepresentation
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
